// Contact-page FAQ — focuses on the enquiry, site-visit, and response
// process. Different from the homepage brand-FAQ to give the Contact
// page its own unique long-tail coverage (e.g. "site visit Nagpur",
// "response time real estate Nagpur") without duplicating the homepage.
const contactFaq = [
  {
    question: "How do I contact Siddhivinayak Group for a property enquiry?",
    answer:
      "Reach the team via three channels: phone +91 98232 60303 (Mon–Sat, 10:00–19:00), email mail@kunalpadole.com (response within 4 working hours), or the website enquiry form which routes to a project-specific consultant. Walk-ins are welcome at the registered office in Raje Raghuji Nagar, Nagpur 440009.",
  },
  {
    question: "Can I book a free site visit in Nagpur?",
    answer:
      "Yes. Free site visits are available across all five active projects — Hilltop Heights -14, Hilltop Heights -11, Embassy-10, Siddhivinayak Nagari, and Ayodhya City. Pick a 60-minute slot between 10:00 and 18:00 (Mon–Sat), and a project consultant will accompany you on-site with project brochures, layout plans, and sample flat walkthroughs.",
  },
  {
    question: "How quickly does Siddhivinayak Group respond to enquiries?",
    answer:
      "Phone calls and walk-ins are answered in real time during business hours. Email and form enquiries receive a personalised response within 4 working hours. Site-visit requests are confirmed within 30 minutes during business hours and scheduled at the customer's preferred slot.",
  },
  {
    question: "Do I need to pay any fee to book a site visit or consultation?",
    answer:
      "No. Site visits, project consultations, brochures, layout plans, and quote sheets are provided free of cost. There is no booking fee or commitment — Siddhivinayak Group's sales process is fully transparent at the enquiry stage.",
  },
  {
    question: "Which documents should I carry for the first site visit?",
    answer:
      "Carry a government-issued photo ID (Aadhaar / PAN / Driving Licence) for verification at the site gate. If you want a same-day indicative quote, also carry your last 3 months' salary slips or ITR — the consultant can run an eligibility check for bank pre-approved loan offers on the spot.",
  },
  {
    question: "Can I get an online video tour instead of an in-person visit?",
    answer:
      "Yes. Siddhivinayak Group offers live video tours via WhatsApp / Google Meet for outstation and NRI buyers. Each tour runs 30–45 minutes, covers the show flat, sample amenities, and site progress, and is recorded for later reference. Schedule a video tour by emailing mail@kunalpadole.com.",
  },
  {
    question: "Is there a dedicated point of contact after I express interest?",
    answer:
      "Yes. Every enquiry is assigned a named project consultant who handles the customer through booking, agreement, loan processing, registration, and possession. The consultant's direct phone number and email are shared after the first interaction so all queries route to one person — not a call centre.",
  },
  {
    question: "What are the office hours for Siddhivinayak Group Nagpur?",
    answer:
      "Office hours are Monday to Saturday, 10:00 to 19:00 IST. The office is closed on Sundays and public holidays declared by the Government of Maharashtra. For urgent support outside business hours, email mail@kunalpadole.com — enquiries are queued and addressed the next working day.",
  },
];

export default contactFaq;